import {
    leadsPaidCommunitySubmission,
    leadsPaidPlanSubmission,
    leadsPaidSpecSubmission,
    getPdfBrochureUrl
} from 'constants/routes';

export const postBuildablePlanBrochure$ = (payload) => {
  const requestObject = {
    'credentials': 'include',
    method: 'POST',
    body: JSON.stringify({
      leadCommand: {
        ...payload,
      },
    }),
    headers: {
      'Content-Type': 'application/json',
    },
    selector: (response) => response.text(),
  };

  fetch(leadsPaidCommunitySubmission, requestObject);
};

export const postCommunityBrochure = (payload) => {
  const requestObject = {
    'credentials': 'include',
    method: 'POST',
    body: JSON.stringify({
      leadCommand: {
        ...payload,
      },
    }),
    headers: {
      'Content-Type': 'application/json',
    },
    selector: (response) => response.text(),
  };

  fetch(leadsPaidCommunitySubmission, requestObject);
};

export const postPlanBrochure = (payload) => {
  const requestObject = {
    'credentials': 'include',
    method: 'POST',
    body: JSON.stringify({
      leadCommand: {
        ...payload,
      },
    }),
    headers: {
      'Content-Type': 'application/json',
    },
    selector: (response) => response.text(),
  };

  fetch(leadsPaidPlanSubmission, requestObject);
};

export const postSpecBrochure = (payload) => {
  const requestObject = {
    'credentials': 'include',
    method: 'POST',
    body: JSON.stringify({
      leadCommand: {
        ...payload,
      },
    }),
    headers: {
      'Content-Type': 'application/json',
    },
    selector: (response) => response.text(),
  };

  fetch(leadsPaidSpecSubmission, requestObject);
};

/**
 * getBrochureDownloadUrl: Fetches the URL for downloading a brochure based on the provided payload.
 * This method constructs a request to the server, appends query parameters, and returns the response.
 *
 * @param {object} payload - An object containing the necessary parameters for the request.
 * @param {object} payload.parameters - The parameters required to construct the request.
 * @param {string} payload.parameters.id - The unique identifier for the brochure.
 * @param {string} payload.parameters.pdfbrochuretype - The type of brochure to download.
 * @returns {Promise} - A promise that resolves to the response from the server.
 */
export const getBrochureDownloadUrl = (payload) => {

  // Construct the query parameters
  const queryParams = new URLSearchParams({
    id: payload.parameters.id,
      brochuretype: payload.parameters.pdfbrochuretype,
  });

  // Append the query parameters to the URL
  const urlWithParams = `${getPdfBrochureUrl}?${queryParams.toString()}`;

  const requestObject = {
    'credentials': 'include',
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
    selector: (response) => response.text(),
  };

  return fetch(urlWithParams, requestObject);
};
